import React, {useEffect} from "react"
import {layoutSidebarLeftWidth} from "../settings"
import {useHelp, useRoomParameters, useRoomSetup, useLocal} from "../AppContext"
import {CtaBubble, CtaBubbleLabel} from "../Components/CtaBubble"
import {MenuLeft, MenuLeftLabel} from "../Components/MenuLeft"
import {SelectItem, SelectItemAlignCenter} from "../Components/Menu/SelectItem"
import style from "./Conditions.css"

export const Conditions = () => {
    const local = useLocal()
    const help = useHelp()

    useEffect(() => {
        help.setContext('preisfenster-brandschutz')
    }, [])

    return <>
        <MenuLeft label={local.__("Empfehlungshilfe")}>
            <MenuLeftLabel label={local.__("Preisfenster")}/>
            <BudgetOptions/>
            <MenuLeftLabel label={local.__("Brandschutz")} customStyle={{marginTop: "20px"}}/>
            <FireProtectionOptions/>
        </MenuLeft>
        <CtaBubble name={"conditions"} left={layoutSidebarLeftWidth + 40} top={155}>
            <CtaBubbleLabel>
                {local.__("Empfehlungshilfe")}
            </CtaBubbleLabel>
            <div dangerouslySetInnerHTML={{__html: local.__("Bitte wählen sie ein Preisfesnter und die Brandschutzeingenschaften")}}/>
        </CtaBubble>
    </>
}

export const FireProtectionOptions = () => {
    const local = useLocal()
    const roomParameters = useRoomParameters()
    const roomSetup = useRoomSetup()

    return roomParameters.getFireProtectionClasses().map((fireProtectionClass, index) => {
        const isActive = fireProtectionClass.code === roomSetup.getFireProtectionClass()

        const onClick = () => {
            roomSetup.setFireProtectionClass(fireProtectionClass.code)
        }

        return <SelectItemAlignCenter key={index} isActive={isActive} onClick={onClick}>
            {local.getLabel(fireProtectionClass.name)}
        </SelectItemAlignCenter>
    })
}

export const BudgetOptions = () => {
    const roomParameters = useRoomParameters()
    const roomSetup = useRoomSetup()
    const local = useLocal()

    const budgets = roomParameters.getBudgets(roomSetup.getType()).map(budget => ({
        value: budget,
        label: local.currencyPlain(budget),
    }))

    budgets.unshift({
        value: null,
        label: local.__("offenes Preisfenster")
    })

    const options = budgets.map((budget, index) => {
        const isActive = !roomSetup.isCustomBudget() && budget.value === roomSetup.getBudget()
        const onSelect = () => {
            roomSetup.unsetCustomBudget()
            roomSetup.setBudget(budget.value)
        }
        return <SelectItemAlignCenter key={index} isActive={isActive} onClick={onSelect}>
            {budget.label}
        </SelectItemAlignCenter>
    })

    const setCustomValue = event => {
        roomSetup.setBudget(event.target.value)
    }

    const getCustomValue = () => {
        if (!roomSetup.isCustomBudget() || roomSetup.getBudget() === null) {
            return ""
        }

        return roomSetup.getBudget()
    }

    options.push(<SelectItem key={options.length} isActive={roomSetup.isCustomBudget()} onClick={() => roomSetup.setCustomBudget()}>
        {local.__("eigene Budgetgrenze")}
        <input className={style.budgetInput} type="number" step={100} min={100} disabled={!roomSetup.isCustomBudget()} value={getCustomValue()} onChange={setCustomValue}/>
    </SelectItem>)

    return options
}